<!-- 节能基数配置 -->
<template>
    <div class="container">
        <el-form :model="form" ref="form" :rules="fromRule" label-width="100px" class="demo-dynamic">
            <!-- <el-form-item
                prop="plc_terminal_type"
                label="设备类型"
                :rules="[
                    { required: true, message: '请选择设备类型', trigger: 'change' }
                ]">
                <el-select v-model="form.plc_terminal_type" placeholder="设备类型" @change="handleChange">
                    <el-option
                        v-for="(item, index) in sysCodeList"
                        :key="index+ 'sysCodeList'"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item> -->
            <div class="month-list">
                <div class="month-item" v-for="(domain, index) in form.month_basic_energy" :key="index + 'month_basic_energy'">
                    <el-form-item
						v-show="showsum" 
                        :label="index+1 + '月份'"
                        :prop="'month_basic_energy.' + index + '.energy_sum'"
                        :rules="[
							{required: true, message: '用量不能为空'},
							{type: 'number', message: '请输入数字值'}
						]">
                            <el-input v-model.number="domain.energy_sum" placeholder="请输入基础用量"></el-input>
                    </el-form-item>					
                    <el-form-item
						v-show="showrate"
                        :label="index+1 + '月份'"
                        :prop="'month_basic_energy.' + index + '.energy_saving_rate'"
                        :rules="{required: true, message: '用量不能为空'}"
						>
                            <el-input v-model="domain.energy_saving_rate"  placeholder="请输入节能率"></el-input>
                    </el-form-item>
                </div>
            </div>
            <el-form-item>
				<el-button type="primary" @click="changeshow">{{text}}</el-button>
                <el-button type="primary" @click="submitForm">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Service from '@/api/Service'
var checkNumber = (rule, value, callback) => {
    if (!value) {
		if(value !== 0){
			return callback(new Error('用量不能为空'));
			
		}   
    }
    setTimeout(() => {
        if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
        } else {
            callback();
        }
    }, 1000);
};

const month_basic = [
    {
        month: 'January',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'February',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'March',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'April',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'May',
        energy_sum:0,
        energy_saving_rate: 0,
    },
    {
        month: 'June',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'July',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'August',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'September',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'October',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'November',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
    {
        month: 'December',
        energy_sum: 0,
        energy_saving_rate: 0,
    },
]
export default {
    name: "energybase",
    data() {
        
        return {
			showsum:true,
			showrate:false,
			text:'切换节能率',
            sysCodeList: [],
            form: {
                // plc_terminal_type: '',
                month_basic_energy: JSON.parse(JSON.stringify(month_basic)),
            },
            fromRule: {}
        };
    },

    components: {},

    computed: {},
    created() {
        // this.getSysValue();
        this.getData()
    },
    methods: {
        checkNumber,
        // async getSysValue() {
        //     let type_code = 'plc_terminal_type'
        //     let res = await Service.getTypeCodeSystemDic({type_code})
        //     if(res) {
        //         this.sysCodeList = res
        //         this.activeName = res[0].code
        //     }
        // },
		async changeshow(){
			
			if(this.showrate){
				this.text="切换节能率"
				this.form.is_by_rate = false
			}else{
				this.text="切换节能基数"
				this.form.is_by_rate = true
			}
			this.showrate = !this.showrate
			this.showsum  = !this.showsum
			let res = await Service.getEnergyConfig()
			this.form.month_basic_energy = res.list[0].month_basic_energy
		},
        async getData() {
            let res = await Service.getEnergyConfig()
            if(res != 'success' && res.list.length>0) {
                this.form.month_basic_energy = res.list[0].month_basic_energy
                this.form.oid = res.list[0].oid
				
				if(res.list[0].is_by_rate){
					this.showrate = true
					this.showsum =false
					this.text="切换节能基数"
					this.form.is_by_rate = true
				}else{
					this.showrate = false
					this.showsum =true
					this.text="切换节能率"
					this.form.is_by_rate = false
				}
            }
        },
        // async handleChange(val) {
        //     this.form.month_basic_energy = JSON.parse(JSON.stringify(month_basic));
        //     let res = await Service.getEnergyConfigBytype({})
        //     if(res != 'success') {
        //         this.form.oid = res.oid;
        //         // this.form.plc_terminal_type = res.plc_terminal_type;
        //         this.form.month_basic_energy = res.month_basic_energy;
        //     }
        // },
        submitForm() {
			
            this.$refs['form'].validate(async (valid) => {
                if (valid) {
                    let res 
                    let params = Object.assign({}, this.form)
					for(var i=0;i<12;i++){
						let a = parseFloat(this.form.month_basic_energy[i].energy_saving_rate) ? parseFloat(this.form.month_basic_energy[i].energy_saving_rate) : 0
						this.form.month_basic_energy[i].energy_saving_rate = a
					}
                    params.month_basic_energy = JSON.stringify(this.form.month_basic_energy)
                    if(this.form.oid) {
                        // 修改
                        res = await Service.editEnergyConfig(params)
                    }else{
                        // 增加
                        res = await Service.addEnergyConfig(params)
                    }
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};
</script>
<style lang='less' scoped>

.month-list{
    width: 100%;
    font-size: 0;
    .month-item{
        display: inline-block;
        width: 50%;
        vertical-align: middle;
        font-size: 14px;
    }
}
</style>